import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import '../assets/css/image.css'

function PGImage({ src, alt, title, onClick }) {
  const [error, setError] = useState(false);
  const defaultSrc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQuzJkT03q70O7M94XsPrbJtq42SygxDQz4AAjAIi4Vrhn-ZGviESECmy3akBb_MtmSJQ&usqp=CAU";


  return (
    <div className="image-container" onClick={onClick}>
      <Image
        src={error ? defaultSrc : src}
        alt={alt}
        onError={() => setError(true)}
        className={error ? "blurred" : ""}
        fluid
      />
      {error && <div className="overlay-title">{title}</div>}
    </div>
  );
}

export default PGImage;
